<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">合同名称：</span>
        </div>
        <el-select v-model="contractCodes"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入企业名称选择合同">
          <el-option v-for="item in contractList" :key="item.code"
                     :label="item.contractText" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line" v-if="contractCodes">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">合同编号：</span>
        </div>
        <el-input v-model="formData.contractCode" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line" v-if="contractCodes">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">住户名：</span>
        </div>
        <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line" v-if="contractCodes">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">房间号：</span>
        </div>
        <el-input v-model="formData.roomInfoName" size="small" style="width: 280px" disabled/>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">补交物业费区间：</span>
        </div>
<!--        <el-input v-model="formData.ledgerDuration" size="small" style="width: 280px" />-->
        <el-date-picker
          v-model="timevalue"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          style="width: 280px">
        </el-date-picker>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">电量计费周期：</span>
        </div>
        <el-input v-model="formData.electricityDuration" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">用电额度：</span>
        </div>
        <el-input v-model="formData.yearElectricityQuota" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">总用电量：</span>
        </div>
        <el-input v-model="formData.yearElectricity" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">补交物业费单价：</span>
        </div>
        <el-input v-model="formData.overPrice" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">补交物业费：</span>
        </div>
        <el-input v-model="formData.overMoney" size="small" style="width: 280px" />
      </div>
    </form>
    <div class="form-btn-box">
      <button-confirm @confirm="confirm" />
      <button-cancel @cancel="cancel" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/PropertyFee";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "property-fee-management-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "纳爱斯专属",
          name: "property-fee-management"
        },
        {
          value: "物业费台账"
        }
      ],
      mainTitle: "添加物业费信息",
      subheading: "",
      formData: {
      },
      contractCodes:"",
      contractList:[],
      timevalue:[]
    };
  },
  created() {
    // this.remoteMethod();
  },
  methods: {
    remoteMethod(query) {
      this.getContractList(query);
    },
    getContractList(searchKey) {
      if (searchKey&&searchKey.length<2){
        return false;
      }
      this.$axios
        .post(api.searchFinancePropertyLedgerContract, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v=>{
              v.contractText=v.code+'/'+v.enterpriseName
            })
            this.contractList = list;
          }
        })
        .catch(errorHandler("获取合同列表失败"));
    },
    confirm() {
      if(this.timevalue){
        this.formData.ledgerDuration=this.timevalue[0]+' - '+this.timevalue[1]
      }
      if (!this.formData.contractCode) {
        nError("请选择合同名称");
        return false;
      }
      this.$axios
        .post(api.addFinancePropertyLedgerFromContract, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.$router.push({
              name: "property-fee-management"
            });
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.$router.push({
        name: "property-fee-management"
      });
    }
  },
  watch:{
    contractCodes(val){
      this.contractList.map(v=>{
        if(v.code==val){
          this.formData.enterpriseName=v.enterpriseName
          this.formData.contractCode=v.code
          this.formData.roomInfoName=v.roomInfoName
          this.formData.enterpriseCode=v.enterpriseCode
        }
      })
    }
  }
};
</script>

<style lang="less">
.el-date-editor .el-range-separator{
  width:10% !important;
}
</style>



// WEBPACK FOOTER //
// src/view/PropertyFee/PropertyFeeManagement/PropertyFeeManagementAdd.vue